// src/pages/SkillDetailPage.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { SKILL_TYPES, SKILL_CATEGORIES } from './SkillsPage';

const SkillDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoc(doc(db, 'skills', id))
      .then(snap => { if (snap.exists()) setListing({ id: snap.id, ...snap.data() }); })
      .catch(e => console.error(e))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><div className="spinner" /></div>;
  if (!listing) return <div className="empty-state"><div className="empty-state-title">Not found</div></div>;

  const t = SKILL_TYPES[listing.type] || SKILL_TYPES.offer_skill;
  const cat = SKILL_CATEGORIES.find(c => c.value === listing.category);

  return (
    <div className="page" style={{ background: 'var(--cream)', padding: '52px 20px 32px' }}>
      <button onClick={() => navigate(-1)} style={s.backBtn}>← Back</button>

      <div style={{ ...s.typeBadge, background: t.color }}>{t.emoji} {t.label}</div>
      <h1 style={s.title}>{listing.title}</h1>
      {cat && <div style={s.cat}>{cat.emoji} {cat.label}</div>}

      {listing.description && <div style={s.desc}>{listing.description}</div>}

      {listing.postedByName && (
        <div style={s.postedBy}>Posted by {listing.postedByName}</div>
      )}

      <div style={s.contactRow}>
        {listing.contactEmail && (!listing.contactPrefs || listing.contactPrefs.includes('email')) && (
          <a href={`mailto:${listing.contactEmail}?subject=${encodeURIComponent('Re: ' + listing.title + ' on Gather')}`} style={s.contactBtn}>
            ✉️ Get in touch
          </a>
        )}
        {listing.contactPhone && (!listing.contactPrefs || listing.contactPrefs.includes('call')) && (
          <a href={`tel:${listing.contactPhone}`} style={s.contactBtnSec}>
            📞 Call
          </a>
        )}
        {listing.contactPhone && (!listing.contactPrefs || listing.contactPrefs.includes('text')) && (
          <a href={`sms:${listing.contactPhone}`} style={s.contactBtnSec}>
            💬 Text
          </a>
        )}
        {!listing.contactEmail && !listing.contactPhone && (
          <div style={{ fontSize: 13, color: 'var(--muted)' }}>
            No contact details provided.
          </div>
        )}
      </div>
    </div>
  );
};

const s = {
  backBtn: { background: 'none', border: 'none', color: 'var(--sage-dark)', fontSize: 14, fontWeight: 700, cursor: 'pointer', padding: 0, marginBottom: 18 },
  typeBadge: { display: 'inline-block', color: 'white', fontSize: 12, fontWeight: 700, borderRadius: 100, padding: '5px 12px', marginBottom: 10 },
  title: { fontSize: 24, fontWeight: 800, color: 'var(--ink)', marginBottom: 6, lineHeight: 1.25 },
  cat: { fontSize: 13, color: 'var(--muted)', fontWeight: 600, marginBottom: 16 },
  desc: { fontSize: 15, color: 'var(--ink)', lineHeight: 1.6, marginBottom: 20 },
  postedBy: { fontSize: 13, color: 'var(--muted)', fontWeight: 600, marginBottom: 24 },
  contactRow: { display: 'flex', gap: 10 },
  contactBtn: {
    flex: 1, textAlign: 'center', padding: '13px 16px', borderRadius: 14,
    background: 'var(--sage-deep)', color: 'white', fontWeight: 700, fontSize: 14,
    textDecoration: 'none',
  },
  contactBtnSec: {
    flex: 1, textAlign: 'center', padding: '13px 16px', borderRadius: 14,
    background: 'var(--sage-pale)', color: 'var(--sage-dark)', fontWeight: 700, fontSize: 14,
    textDecoration: 'none',
  },
};

export default SkillDetailPage;
